import { useContext } from "react"
import { Input, Tabs, Form } from 'antd';
import Context from '../../context/appContext';

//Images
import Empresario from '../../assets/images/empresario.png';

export default function ValidationError() {

    const { folio, showFinalMessage } = useContext(Context);

    return (
        <div className="validationerror-tabs">
            {showFinalMessage && (<Tabs defaultActiveKey="1">
                <Tabs.TabPane tab={<span><em className="fas fa-braille" />Cotización</span>} key="1">
                    <div className="validationerror-container">
                        <p className="validationerror-container__description">
                            Dado el momento de vida en el que te encuentras y para ofrecerte un seguro que se adecue mejor a tus necesidades, un ejecutivo de SURA se comunicará contigo
                        </p>
                        <div className="validationerror-container__content">
                            <div className="validationerror-container__content__img">
                                <img src={Empresario} alt="Empresario" />
                            </div>
                            <Form.Item label='N° Folio'>
                                <Input placeholder={folio ? folio : '00000'} disabled />
                            </Form.Item>
                        </div>
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab={<span><em className="fas fa-braille" />Llámanos</span>} key="2">
                    <div className="validationerror-container">
                        <p className="validationerror-container__description">Si lo prefieres, comunícate con nosotros para continuar con la contratación de tu seguro. Ten a la mano tu número de folio.</p>
                        <div className="validationerror-container__actions">
                            <em className="fas fa-mobile-android-alt" />
                            <div className="validationerror-container__actions__phone">
                                <strong>Atención a clientes</strong>
                                <p>55 5723 7999</p>
                            </div>
                        </div>
                    </div>
                </Tabs.TabPane>
            </Tabs>)}
        </div>
    )
}